import React, { useEffect, useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { AiOutlineDashboard } from "react-icons/ai";
import {
    RiContactsLine,
    RiQuestionAnswerLine,
    RiImage2Line,
    RiBankLine,
    RiMoneyDollarCircleLine,
    RiCoupon3Line,
    RiShareLine
} from "react-icons/ri";
import { MdOutlineFeaturedPlayList, MdOutlineHistory } from "react-icons/md";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Link, Outlet, useNavigate } from "react-router-dom";
import { Layout, Menu, Grid, theme } from "antd";

import { logout as logoutApi } from "../../services/apiService";

import logo from "../../assets/images/sharkLogo.png";
import smallLogo from "../../assets/images/sharkLogo.png";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

const MainLayout = () => {
    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();
    const screens = useBreakpoint();

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // ✅ Proper Logout Handler
    const handleLogout = async () => {
        try {
            await logoutApi(); // Call backend logout
        } catch (error) {
            console.warn("Logout API failed, forcing logout.");
        } finally {
            // Remove authentication data
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("isLoggedIn");
            localStorage.removeItem("user");

            sessionStorage.clear();

            toast.success("Logged out successfully");

            setTimeout(() => {
                navigate("/Admin-Login", { replace: true });
            }, 800);
        }
    };

    const handleMenuClick = ({ key }) => {
        navigate(key);
    };

    return (
        <>
            <Layout>
                {/* Sidebar */}
                <Sider
                    trigger={null}
                    collapsible
                    collapsed={collapsed}
                    breakpoint="md"
                    collapsedWidth="50"
                    style={{ minHeight: "100vh", background: "#0B1120" }}
                >
                    <div className="logo text-center py-3">
                        <img
                            src={collapsed ? smallLogo : logo}
                            alt="Logo"
                            style={{
                                width: collapsed ? "40px" : "150px",
                                transition: "width 0.3s",
                            }}
                        />
                    </div>

                    <Menu
                        theme="dark"
                        mode="inline"
                        onClick={handleMenuClick}
                        items={[
                            {
                                key: "/Dashboard",
                                icon: <AiOutlineDashboard className="fs-4" />,
                                label: "Dashboard",
                            },
                            {
                                key: "/FeaturePlatform",
                                icon: <MdOutlineFeaturedPlayList className="fs-4" />,
                                label: "Game Management",
                            },
                            {
                                key: "/Transactions",
                                icon: <MdOutlineHistory className="fs-4" />,
                                label: "Transactions History",
                            },
                            {
                                key: "/Sessions",
                                icon: <RiImage2Line className="fs-4" />,
                                label: "Sessions Management",
                            },
                            {
                                key: "/Deposit",
                                icon: <RiBankLine className="fs-4" />,
                                label: "Deposit",
                            },
                            {
                                key: "/Credit",
                                icon: <RiMoneyDollarCircleLine className="fs-4" />,
                                label: "Credit",
                            },
                            {
                                key: "/Promotions",
                                icon: <RiCoupon3Line className="fs-4" />,
                                label: "Promotions",
                            },
                            {
                                key: "/FAQs",
                                icon: <RiQuestionAnswerLine className="fs-4" />,
                                label: "FAQs",
                            },
                            {
                                key: "/SocialMedia",
                                icon: <RiShareLine className="fs-4" />,
                                label: "Social Media",
                            },
                            {
                                key: "/ContactUs",
                                icon: <RiContactsLine className="fs-4" />,
                                label: "Contact Us",
                            },
                        ]}
                    />
                </Sider>

                {/* Main Layout */}
                <Layout>
                    {/* Header */}
                    <Header
                        className="d-flex justify-content-between w-full align-items-center px-4"
                        style={{ color: "white", background: "#101828", borderBottom: "1px solid rgba(30,144,255,0.12)" }}
                    >
                        <div className="d-flex align-items-center gap-3">
                            {React.createElement(
                                collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                                {
                                    className: "trigger",
                                    onClick: () => setCollapsed(!collapsed),
                                }
                            )}
                            <img
                                src={logo}
                                alt="Blue Shark"
                                style={{ height: "40px", objectFit: "contain" }}
                            />
                        </div>

                        <div className="d-flex gap-0 align-items-center">
                            <div className="dropdown">
                                <div
                                    role="button"
                                    id="dropdownMenuLink"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {!screens.xs && (
                                        <div className="d-flex flex-column gap-2">
                                            <h6 className="mb-0">Admin</h6>
                                            <h6 className="mb-0" style={{ fontSize: "0.75rem", color: "#b0c4de" }}>
                                                {JSON.parse(localStorage.getItem("user") || "{}")
                                                    ?.email || ""}
                                            </h6>
                                        </div>
                                    )}
                                </div>

                                <ul
                                    className="dropdown-menu dropdown-menu-end"
                                    aria-labelledby="dropdownMenuLink"
                                >
                                    <li>
                                        <Link to="/profile" className="dropdown-item">
                                            View Profile
                                        </Link>
                                    </li>
                                    <li>
                                        <button
                                            className="dropdown-item text-danger"
                                            onClick={handleLogout}
                                        >
                                            Sign out
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Header>

                    {/* Content */}
                    <Content
                        style={{
                            background: "#0B1120",
                            minHeight: "100vh",
                            padding: "10px",
                        }}
                    >
                        <ToastContainer
                            position="top-right"
                            autoClose={250}
                            newestOnTop
                            closeOnClick
                            draggable
                            theme="dark"
                        />
                        <Outlet />
                    </Content>
                </Layout>
            </Layout>
        </>
    );
};

export default MainLayout;
